import { Grid, Typography, Box, Button, Tab, Tabs } from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ConnectorsList from "./ConnectorsList";
import MetadataPage from "./MetadataPage";
import UiConfigPage from "./UIConfigPage";
import TransformationPage from "./TransformationPage";
// type Props = {};

const Configuration = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [value, setValue] = useState(0);
  const [activeTab, setActiveTab] = useState("metadata-tab");

  useEffect(() => {
    if (location.pathname.includes("ui-config")) {
      setValue(1);
      setActiveTab("ui-config-tab");
    } else if (location.pathname.includes("connectors")) {
      setValue(2);
      setActiveTab("connectors-tab");
    } else if (location.pathname.includes("transformation")) {
      setValue(3);
      setActiveTab("transformation-tab");
    } else {
      setValue(0);
      setActiveTab("metadata-tab");
    }
  }, [location.pathname]);

  const handleTabChange = (event: any, newValue: any) => {
    setValue(newValue);
    const tabId = event.target.id;
    setActiveTab(tabId);
    if (tabId === "metadata-tab") {
      navigate("/configuration");
    } else if (tabId === "ui-config-tab") {
      navigate("/configuration/ui-config");
    } else if (tabId === "connectors-tab") {
      navigate("/configuration/connectors");
    } else if (tabId === "transformation-tab") {
      navigate("/configuration/transformation");
    }
  };

  const handleAdd = () => {
    if (activeTab === "connectors-tab") {
      navigate("/configuration/connectors/add-connector");
    }
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs>
          <Typography variant="h4" gutterBottom>
            Configuration
          </Typography>
        </Grid>
        <Grid item>
          <Box display="flex" justifyContent="flex-end" columnGap={2}>
            {activeTab == "connectors-tab" && (
              <Button
                variant="contained"
                endIcon={<AddIcon />}
                id="add_new_connector"
                onClick={handleAdd}
              >
                Add New
              </Button>
            )}
          </Box>
        </Grid>
      </Grid>
      <Tabs
        value={value}
        onChange={handleTabChange}
        aria-label="Configuration Tabs"
        className="expandedTabs"
      >
        <Tab label="KITT Metadata" id="metadata-tab" />
        <Tab label="KITT UI Config" id="ui-config-tab" />
        <Tab label="Connectors" id="connectors-tab" />
        <Tab label="Transformation" id="transformation-tab" />
      </Tabs>
      <Box sx={{ pt: 3 }}>
        {activeTab === "connectors-tab" && <ConnectorsList />}
        {activeTab === "metadata-tab" && <MetadataPage />}
        {activeTab === "ui-config-tab" && <UiConfigPage />}
        {activeTab === "transformation-tab" && <TransformationPage />}
      </Box>
    </>
  );
};

export default Configuration;
